import { Pipe } from '@angular/core';
var SqrtPipe = (function () {
    function SqrtPipe() {
    }
    SqrtPipe.prototype.transform = function (num) {
        return !isNaN(num)
            ? Math.sqrt(num)
            : num;
    };
    return SqrtPipe;
}());
export { SqrtPipe };
SqrtPipe.decorators = [
    { type: Pipe, args: [{ name: 'sqrt' },] },
];
/** @nocollapse */
SqrtPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=sqrt.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/math/sqrt.js
// module id = 244
// module chunks = 4